import { render } from "./tickets-pending.vue?vue&type=template&id=083c69ec"
import script from "./tickets-pending.vue?vue&type=script&lang=js"
export * from "./tickets-pending.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__